import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BnTelaLoginComponent } from "@bndes/bndes-ux4/bn-login";
import { BnErroNaoAutorizadoComponent } from "@bndes/bndes-ux4/bn-erro-nao-autorizado";
import { BnErroPaginaNaoEncontradaComponent } from "@bndes/bndes-ux4/bn-erro-pagina-nao-encontrada";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeComponent } from './features/escolha-modalidade/escolha-modalidade.component';
import { ValidacaoRecaptchaComponent } from './shared/recaptcha/validacao-recaptcha.component';
import { HomeComponent } from './features/home/home.component';
import { EscolhaModalidadeGuard } from './interceptors/escolha-modalidade.guard';
import { AgenteFinanceiroResolver } from './shared/resolvers/agente-financeiro.resolver';
import { LoginNovoComponent } from './login/login-novo.component';
import { TermosComponent } from './features/termos/termos.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginNovoComponent,
    data: [{ solicitarCnpj: true }]// , canReuse: false }]
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'termo', component: TermosComponent, pathMatch: 'full' },
  { path: 'home' , component: HomeComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {agentes: AgenteFinanceiroResolver} },
  { path: 'escolha-modalidade', component: EscolhaModalidadeComponent, canActivate: [AuthenticationGuard]},
  { path: 'validacao-recaptcha', component: ValidacaoRecaptchaComponent},
  { path: 'nao-autorizado', component: BnErroNaoAutorizadoComponent },
  { path: '**', component: BnErroPaginaNaoEncontradaComponent, canActivate: [AuthenticationGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
